module.exports = __webpack_public_path__ + "media/images/lb/948-62cf2f6897b95a8771aa1222f0792b8a.svg";